import { Type } from '@angular/core';

export interface Tab {
    label: string;
    component?: Type<any>;
    data?: any;
    disabled?: boolean;
    permissionLabel?: string;
    highlighted?: boolean;
    link?: string;
    key?: TabKeyEnum;
    icon?: string;
}

export enum TabKeyEnum {
    ASSETS = 'assets',
    CONTENT_AREA = 'content',
    VISUALS_AREA = 'visuals',
    CHANNEL_DISTRIBUTION_STATUS = 'channel-distribution-status',
    FULL_EXPORT = 'full-export',
    EXPORTS_MONITORING = 'exports-monitoring',
    IMPORTS_MONITORING = 'imports-monitoring',
    VISUAL_ROOMS = 'rooms',
    DISTRIBUTION = 'distribution',
    VISUAL_ROOM_TYPE_MANAGER = 'roomTypeManager',
    IMPORTS_RUNNER = 'imports-runner',
    PHOTO_ORGANIZER = 'photoOrganizer',
    CATEGORIES = 'categories',
    IMAGE_TRACKER = 'imageTracker',
}

export interface TabOrderAdjustment {
    displayBefore?: TabKeyEnum;
    displayAfter?: TabKeyEnum;
}
